// ==================== TRANSFORMATION METRICS ====================

export const TRANSFORMATION_METRICS = {
  leading: {
    adoption: [
      { metric: 'User Activation Rate', description: 'Percentage of users actively using AI tools', target: '> 70%', frequency: 'Weekly' },
      { metric: 'Feature Usage', description: 'Usage rate of AI features', target: '> 60%', frequency: 'Weekly' },
      { metric: 'Training Completion', description: 'Percentage of employees trained', target: '100%', frequency: 'Monthly' }
    ],
    pipeline: [
      { metric: 'Use Cases in Pipeline', description: 'Number of AI use cases being developed', target: '> 20', frequency: 'Monthly' },
      { metric: 'Time to Deploy', description: 'Time from ideation to deployment', target: '< 2 weeks', frequency: 'Monthly' },
      { metric: 'Model Iteration Rate', description: 'Frequency of model updates', target: 'Weekly', frequency: 'Monthly' }
    ]
  },
  
  lagging: {
    financial: [
      { metric: 'EBITDA Impact', description: 'Incremental EBITDA from AI', target: '+15%', frequency: 'Quarterly' },
      { metric: 'Cost Savings', description: 'Total cost reduction', target: '-20%', frequency: 'Quarterly' },
      { metric: 'ROI', description: 'Return on AI investment', target: '> 300%', frequency: 'Annual' }
    ],
    operational: [
      { metric: 'Process Efficiency', description: 'Improvement in process efficiency', target: '+30%', frequency: 'Monthly' },
      { metric: 'Error Rate', description: 'Reduction in error rate', target: '-90%', frequency: 'Monthly' },
      { metric: 'Cycle Time', description: 'Reduction in cycle time', target: '-40%', frequency: 'Monthly' }
    ]
  },
  
  valueRealization: {
    quickWins: {
      timeframe: '0-3 months',
      expectedValue: '10-15% of total',
      metrics: ['Cost savings', 'Time savings', 'Quick ROI']
    },
    mediumTerm: {
      timeframe: '3-9 months',
      expectedValue: '30-40% of total',
      metrics: ['Revenue uplift', 'Process improvement', 'Customer satisfaction']
    },
    longTerm: {
      timeframe: '9-24 months',
      expectedValue: '50-60% of total',
      metrics: ['EBITDA impact', 'Market share', 'Competitive advantage']
    }
  }
};

export const SUCCESS_SCORECARD = {
  categories: [
    {
      category: 'Business Value',
      weight: 0.30,
      metrics: [
        { name: 'EBITDA Impact', weight: 0.40, target: '+15%' },
        { name: 'Revenue Growth', weight: 0.30, target: '+15%' },
        { name: 'Cost Reduction', weight: 0.30, target: '-20%' }
      ]
    },
    {
      category: 'Adoption',
      weight: 0.25,
      metrics: [
        { name: 'User Adoption', weight: 0.40, target: '> 70%' },
        { name: 'Process Integration', weight: 0.30, target: '> 80%' },
        { name: 'Training Completion', weight: 0.30, target: '100%' }
      ]
    },
    {
      category: 'Technical',
      weight: 0.25,
      metrics: [
        { name: 'Model Accuracy', weight: 0.30, target: '> 90%' },
        { name: 'System Availability', weight: 0.30, target: '> 99.9%' },
        { name: 'Performance', weight: 0.40, target: 'Meets SLA' }
      ]
    },
    {
      category: 'Innovation',
      weight: 0.20,
      metrics: [
        { name: 'Use Cases Deployed', weight: 0.40, target: '10+' },
        { name: 'Time to Deploy', weight: 0.30, target: '< 1 week' },
        { name: 'New Capabilities', weight: 0.30, target: '5+' }
      ]
    }
  ]
};